import { Button, Link, FormControl, FormLabel, Input, Modal, ModalClose, ModalDialog, ModalOverflow, Stack, Typography, Select, Option, Autocomplete, Textarea, IconButton, Card, CardContent, Chip, DialogTitle, Divider, DialogContent, DialogActions } from "@mui/joy";
import { useContext, useEffect, useState } from "react";
import { LayoutContext } from "../../context";
import { motion, AnimatePresence } from "framer-motion";
import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";
import { APICreateEvent, APIDeleteEvent, APIGetEmployee, APIUpdateDeals, APIUpdateEvent } from "../../api";
import Cookies from "js-cookie";
import CachedRoundedIcon from '@mui/icons-material/CachedRounded';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { Alert } from '@mui/joy';
import { eventDeleteError } from '../../utils/eventDeleteError';


export default function ModalQuest() {
    const { modalQuest, setModalQuest, setModalEvent, updateListEvents, dateRange, tokenEmployee } = useContext(LayoutContext);

    const [ isLoad, setIsLoad ] = useState(false);
    const [deleteError, setDeleteError] = useState('');
    useEffect(() => { setDeleteError(''); }, [modalQuest.open, modalQuest.id_event]);

    async function deleteEvent() {
        // console.log("Начало deleteEvent");
        const token = tokenEmployee;
        // console.log("Токен:", token);
        
        if (!token) return;
        
        setIsLoad(true);
        setDeleteError('');
        try {
            console.log("Вызов APIDeleteEvent");
            const data = await APIDeleteEvent(token, modalQuest?.id_event);
            console.log("Результат APIDeleteEvent:", data);
            
            if (data?.status === "ok") {
                console.log("Удаление успешно, закрытие модалок");
                setModalQuest({ id_event: null, open: false });
                setModalEvent({ event: null, open: false, del: true });
                
                updateListEvents(null, null, dateRange.startDate, dateRange.endDate, true);
                console.log("updateListEvents вызван");
            } else {
                setDeleteError(eventDeleteError(data));
            }
        } catch (error) {
            setDeleteError(eventDeleteError(error));
        } finally {
            setIsLoad(false);
        }
    }

    
    return (
        <AnimatePresence>
            {
                modalQuest.open && (
                    <Modal
                        sx={{ zIndex: 10102 }}
                        open={modalQuest.open}
                        onClose={() => setModalQuest({ ...modalQuest, open: false })}
                        slotProps={{
                            backdrop: {
                                component: motion.div,
                                initial: { opacity: 0, backdropFilter: 'blur(0px)' },
                                animate: { opacity: 1, backdropFilter: 'blur(8px)' },
                                exit: { opacity: 0, backdropFilter: 'blur(0px)' },
                                transition: { duration: 0.3, ease: "easeInOut" },
                            }
                        }}
                    >
                        <ModalOverflow sx={{ height: 'auto' }}>
                            <ModalDialog
                                size="lg"
                                component={motion.div}
                                initial={{ opacity: 0, y: -10, scale: 0.98 }}
                                animate={{ opacity: 1, y: 0, scale: 1 }}
                                exit={{ opacity: 0, y: 10, scale: 0.98 }}
                                transition={{ duration: 0.2, ease: "easeInOut" }}
                                sx={(theme) => ({
                                    [theme.breakpoints.up("xl")]: {
                                        width: '550px',
                                        mx: 0,
                                    },
                                    [theme.breakpoints.down("xl")]: {
                                        width: '550px',
                                        mx: 0,
                                    },
                                    [theme.breakpoints.down("lg")]: {
                                        width: '550px',
                                        mx: 0,
                                    },
                                    [theme.breakpoints.down("md")]: {
                                        width: '450px',
                                        mx: 0,
                                    },
                                    [theme.breakpoints.down("sm")]: {
                                        width: '95%',
                                        p: 3,
                                    },
                                    width: '100%'
                                })}
                            >
                                <DialogTitle>
                                    <WarningAmberRoundedIcon />
                                    Удаление события
                                </DialogTitle>
                                <Divider />
                                <DialogContent>
                                    Вы уверены что хотите удалить событие?
                                    {deleteError && <Alert color="danger" sx={{ mt: 1.5, overflowWrap: 'anywhere' }}>{deleteError}</Alert>}
                                </DialogContent>
                                <DialogActions>
                                    <Button loading={isLoad} variant="solid" color="danger" onClick={deleteEvent}>
                                        Да, удалить
                                    </Button>
                                    <Button variant="plain" color="neutral" onClick={() => setModalQuest({ id_event: null, open: false })}>
                                        Отмена
                                    </Button>
                                </DialogActions>
                            </ModalDialog>
                        </ModalOverflow>
                    </Modal>
                )
            }
        </AnimatePresence>
    );
}
